module.exports = __webpack_public_path__ + "img/fantasma.86880d3f.svg";